<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud :data="data" v-if="orderId" :option="option" v-model="form" :table-loading="loading" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" @error="error" :before-open="beforeOpenHandle">
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
        </avue-crud>
        <avue-crud :data="data" v-if="!orderId" :option="option" v-model="form" :table-loading="loading" :page.sync="page" ref="crud" @row-del="rowDel" @row-update="rowUpdate" @row-save="rowSave" @on-load="onLoad" @error="error">
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
        </avue-crud>
        <div class="tac mt15" slot>
            <el-button type="primary" size="mini" icon="el-icon-plus" v-if="isShowBtn" @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { remove, update, add, getList } from "@/api/order/orderinit";
import { mapGetters } from "vuex";
import { cardid, isvalidatemobile } from '@/util/validate'
import { getDictTree } from "@/api/system/dictbiz"
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '初始计划单'
        },
        isShowBtn: {
            type: Boolean,
            default: true
        },
        addBtnTitle: {
            type: String,
            default: '添加计划'
        },
        orderId: {
            type: String,
            default: ''
        },
        list: {
            type: Array
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        orderType: {
            type: String,
            default: ""
        },
        initialPlanNo: {
            type: String,
            default: ''
        },
        isSee: {
            type: Boolean,
            default: false
        },
    },
    data() {
        var checkCardid = (rule, value, callback) => {
            let list = cardid(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            let list = isvalidatemobile(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };

        return {
            form: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: this.isOpt,
                viewBtn: this.isSee,
                editBtn: this.isOpt,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                menuBtn: false,
                labelWidth: 120,
                menu: this.isOpt || this.isSee,
                column: [{
                        label: '初始计划单号',
                        // prop: 'initialPlanNo',
                        // orderInitNumber
                        prop: 'initialPlanNo',
                        row: true,
                        disabled: true,
                        span: 24,
                        placeholder: '计划单编号自动生成'
                    },
                    {
                        label: '初始计划单序号',
                        // prop: 'initialPlanNo',
                        // orderInitNumber
                        prop: 'orderInitNumber',
                        row: true,
                        disabled: true,
                        span: 24,
                        placeholder: '计划单编号自动生成'
                    },
                    {
                        label: "机构",
                        prop: "deptId",
                        dataType: 'string',
                        type: 'tree',
                        checkStrictly: true,
                        leafOnly: false,
                        dicUrl: "/api/blade-system/dept/tree",
                        props: {
                            label: 'title'
                        },
                        addDisplay: false,
                        editDisplay: false,
                        viewDisplay: false,
                        rules: [{
                            message: "请选择机构",
                            trigger: "click"
                        }],
                        row: true,
                        span: 24,
                        hide: true,
                        formatter: (row, value, label, column) => {
                            if (value == -1 || !value) {
                                return ""
                            } else {
                                return label
                            }
                        },
                    },
                    {
                        label: "类型",
                        prop: "type",
                        type: "select",
                        dataType: 'string',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: "work_type"
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        row: true,
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择类型",
                            trigger: "click"
                        }]
                    },
                    {
                        label: '建议转派机构',
                        prop: 'description',
                        row: true,
                        span: 24,
                        rules: [{
                            // required: true,
                            trigger: "blur",
                            message: "请输入建议转派机构",
                        }]
                    },
                    {
                        label: '内容',
                        prop: 'content',
                        row: true,
                        span: 24,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            message: "请输入内容",
                        }]
                    },
                    {
                        label: '优先级',
                        prop: 'priority',
                        row: true,
                        span: 24,
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'priority'
                        },

                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        }
                    },
                    {
                        label: '范围',
                        prop: 'planScope',
                        row: true,
                        span: 24,
                        type: "select",
                        dataType: 'number',
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'range_type'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        addDisplay: false,
                        editDisplay: false,
                        rules: [{
                            required: true,
                            trigger: "blur",
                            message: "请选择范围",
                        }]
                    },
                    {
                        label: '开始时间',
                        prop: 'beginTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: '完成时间',
                        prop: 'endTime',
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        prop: "fileUrl",
                        value: '',
                        hide: true,
                        display: false,
                    },
                    {
                        label: '订单id',
                        prop: 'orderId',
                        display: false,
                        hide: true,
                        span: 24,
                        disabled: true
                    }
                ]
            },
            type: ''
        }
    },
    watch: {
        orderId() {
            this.form.orderId = this.orderId
            this.form.initialPlanNo = this.initialPlanNo
        },
        list: {
            deep: true,
            handler(val) {
                this.data = this.list
            }
        },
        orderType() {
            this.init()
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.data = this.list
            let column1 = this.findObject(this.option.column, 'type')
            if (this.orderType) {
                getDictTree().then(res => {
                    let list = res.data.data.filter(v => v.dictValue == '呼叫类型')[0].children
                    let list2 = list.filter(v => v.dictKey == this.orderType)
                    column1.dicData = list2[0].children
                    // this.$refs.crud.updateDic()
                })
            }
        },
        rowSave(row, done, loading) {
            if (!this.orderId) {
                this.data.push(row)
                done();
                this.$emit('getList', this.data)
                return
            }
            row.orderId = this.orderId
            row.initialPlanNo = this.initialPlanNo
            add(row).then(res => {
                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.data.push(res.data.data)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowUpdate(row, index, done, loading) {
            if (!this.orderId) {
                this.$set(this.data, index, row)
                // [index] = row
                done();
                this.$emit('getList', this.data)
                return
            }
            update(row).then(() => {

                this.$message({
                    type: "success",
                    message: "操作成功!"
                });
                this.$set(this.data, index, row)
                this.$emit('getList', this.data)
                done();
            }, error => {
                window.console.log(error);
                loading();
            });
        },
        rowDel(row, index) {
            if (!this.orderId) {
                this.data.splice(index, 1)
                this.$emit('getList', this.data)
                return
            }
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return remove(row.id);
                })
                .then(() => {
                    this.data.splice(index, 1)
                    this.$emit('getList', this.data)
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                });
        },
        onLoad(page, params = {}) {
            this.loading = true;
            if ((this.list && this.list.length > 0) || !this.form.orderId) {
                this.data = this.list || []
                this.page.total = this.data.length;
                this.loading = false;
                return
            }
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
